import React from 'react';
import { Link, LinkProps } from 'react-scroll';
import { SECTION_OFFSET } from './constants.utils';

export type ScrollLinkProps = Omit<LinkProps, 'to' | 'href' | 'spy' | 'onSetActive'> & {
  toId: string;
  onSetActive?(): void;
  onSetInactive?(): void;
  updateHash?: boolean;
};

const ScrollLinkBase = (props: LinkProps) => {
  // @ts-ignore
  return <Link {...(props as any)} />;
};

const ScrollLink = ({
  smooth = true,
  duration = 500,
  onSetActive,
  onSetInactive,
  toId,
  updateHash = true,
  ...props
}: ScrollLinkProps) => {
  const href = `#${toId}`;

  return (
    <ScrollLinkBase
      {...props}
      smooth={smooth}
      spy={true}
      hashSpy={true}
      duration={duration}
      offset={SECTION_OFFSET}
      to={toId}
      href={href}
      onSetActive={onSetActive}
      onSetInactive={onSetInactive}
      delay={100}
    />
  );
};

export default ScrollLink;
